import type { ReactNode } from 'react';
import { NumericFormat } from 'react-number-format';

export type InputProps = {
  value?: string;
  onChange?: (value: string) => void;
  error?: ReactNode;
  suffix?: ReactNode;
  inlineSuffix?: ReactNode;
  scale?: number;
  disabled?: boolean;
  'data-testid'?: string;
};

export const Input = ({
  value = '',
  onChange,
  error,
  suffix,
  scale,
  inlineSuffix,
  'data-testid': dataTestId,
  ...rest
}: InputProps) => {
  return (
    <>
      <div
        className={`border-color-border bg-color-bg-main flex h-10 w-full items-center rounded-md border bg-transparent text-right text-sm text-gray-800 shadow-sm outline-none ${
          error ? 'border-color-border-error' : ''
        } ${rest.disabled ? 'opacity-50' : ''}`}
      >
        <NumericFormat
          inputMode="decimal"
          thousandSeparator=","
          value={value}
          allowNegative={false}
          decimalScale={scale}
          // remove commas
          onChange={e => onChange?.(e.target.value.replaceAll(',', '') || '')}
          placeholder="0.00"
          className="m-2 size-full"
          data-testid={dataTestId}
          {...rest}
        />
        {inlineSuffix}
      </div>
      <div className="mt-1 flex flex-col items-end gap-1 text-right text-xs font-medium [&>*:nth-child(n+3)]:hidden">
        {error && (
          <div data-testid={dataTestId ? dataTestId + '-error' : undefined} className="text-color-text-error">
            {error}
          </div>
        )}
        {suffix}
      </div>
    </>
  );
};
